import React from 'react';

import TabPageContainer from '~components/atoms/TabPageContainer';

import DailyGoldPrice from './DailyGoldPrice';
import AvailableInventory from './AvailableInventory';

import * as Styles from './_dashboard.module.scss';
import { useAppSelector } from '~redux/hooks';
import { ModuleEnum, PermissionsEnum } from '~utils/enums';
import DailySilverPrice from './DailySilverPrice';
import AvailableSilverInventory from './AvailableSilverInventory';

const Dashboard = () => {
    const viewAccessModules = useAppSelector(state => state.auth.userDetails.access).find(access => access.permission === PermissionsEnum.View)?.modules || [];

    return (
        <TabPageContainer>
            <div className={Styles.container}>
                <DailyGoldPrice />

                {
                    viewAccessModules.find(module => module === ModuleEnum.Inventory)
                    && (
                        <AvailableInventory />
                    )
                }

                <DailySilverPrice />

                {
                    viewAccessModules.find(module => module === ModuleEnum.Inventory)
                    && (
                        <AvailableSilverInventory />
                    )
                }
            </div>
        </TabPageContainer>
    );
};

export default Dashboard;
